/* Verdurra — search.js */
(function () {
  'use strict';

  const input      = document.getElementById('search-overlay-input');
  const resultsEl  = document.getElementById('search-results');
  if (!input || !resultsEl) return;

  let debounceTimer;
  let lastQuery = '';

  input.addEventListener('input', function () {
    const query = this.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsEl.innerHTML = '';
      lastQuery = '';
      return;
    }

    if (query === lastQuery) return;
    lastQuery = query;

    debounceTimer = setTimeout(function () {
      performSearch(query);
    }, 280);
  });

  function performSearch(query) {
    const url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,vendor';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const products = data.resources?.results?.products || [];
        renderResults(products, query);
      })
      .catch(function () {
        resultsEl.innerHTML = '';
      });
  }

  function formatMoney(price) {
    const fmt = window.Verdurra?.settings?.moneyFormat || '€{{amount}}';
    const amount = (price / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount);
  }

  function renderResults(products, query) {
    if (!products.length) {
      resultsEl.innerHTML = `
        <div class="search-no-results">
          <p>No results for <strong>"${escapeHtml(query)}"</strong></p>
          <a href="/search?q=${encodeURIComponent(query)}&type=product" class="btn btn--outline btn--sm" style="margin-top:12px">View all results</a>
        </div>`;
      return;
    }

    const items = products.map(function (p) {
      const img   = p.featured_image?.url || p.image || '';
      const price = p.price ? formatMoney(p.price) : '';
      return `
        <a class="search-result-item" href="${p.url}">
          ${img
            ? `<img class="search-result-item__img" src="${img}&width=200" alt="${escapeHtml(p.title)}" width="200" height="200" loading="lazy">`
            : `<div class="search-result-item__img"></div>`}
          <div class="search-result-item__body">
            <div class="search-result-item__title">${escapeHtml(p.title)}</div>
            ${price ? `<div class="search-result-item__price">${price}</div>` : ''}
          </div>
        </a>`;
    }).join('');

    resultsEl.innerHTML = `
      <div class="search-results-grid">${items}</div>
      <div style="text-align:center;margin-top:16px">
        <a href="/search?q=${encodeURIComponent(query)}&type=product" class="btn btn--ghost btn--sm">
          See all results for "${escapeHtml(query)}"
        </a>
      </div>`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Search page filters ──────────────────────────────────── */
  const sortSelect = document.getElementById('search-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── Collection filter form ──────────────────────────────── */
  const filterForm = document.getElementById('facets-form');
  if (filterForm) {

    /* Checkboxes: submit form, but carry any active price params from the URL
       so they aren't lost when a checkbox is toggled. */
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var currentUrl = new URL(window.location.href);
        ['filter.v.price.gte', 'filter.v.price.lte'].forEach(function (param) {
          var val = currentUrl.searchParams.get(param);
          if (val && !filterForm.querySelector('input[name="' + param + '"]')) {
            var h = document.createElement('input');
            h.type  = 'hidden';
            h.name  = param;
            h.value = val;
            filterForm.appendChild(h);
          }
        });
        filterForm.submit();
      });
    });

    /* Price inputs: navigate via URL — conversion (euros → cents) happens
       exactly once here and never touches the form at all. */
    filterForm.querySelectorAll('[data-price-param]').forEach(function (inp) {
      function applyPrice() {
        var url   = new URL(window.location.href);
        var param = inp.dataset.priceParam;
        var val   = inp.value.trim();
        if (val !== '') {
          url.searchParams.set(param, val);
        } else {
          url.searchParams.delete(param);
        }
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }

      inp.addEventListener('change', applyPrice);

      /* Also handle Enter key explicitly so it doesn't trigger form submit */
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyPrice();
        }
      });
    });

    /* Block any native form submit triggered by the price inputs */
    filterForm.addEventListener('submit', function (e) {
      e.preventDefault();
    });
  }

})();
